<template>
  <div>
    <el-form-item label="是否多选">
      <el-switch v-model="activeData.multiple" @change="handleChange" />
    </el-form-item>
    <matrix-option :active-data="activeData" />
  </div>
</template>
<script>
import MatrixOption from './matrix'

import draggable from 'vuedraggable'

export default {
  name: 'ConfigItemMatrixSelect',
  components: {
    MatrixOption,
    draggable
  },
  props: ['activeData'],
  data() {
    return {}
  },
  methods: {
    handleChange() {
      this.$set(this.activeData.config, 'defaultValue', {})
    }
  }
}
</script>

<style lang="scss" scoped></style>
